import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

const EmptyState = ({
  icon,
  title,
  description,
  action,
  className = "",
}: EmptyStateProps): JSX.Element => {
  return (
    <div className={`flex flex-col items-center justify-center rounded-[28px] border border-dashed border-line bg-white/80 px-6 py-14 text-center dark:bg-surface/60 ${className}`.trim()}>
      {icon ? <div className="mb-4 text-brand-500 dark:text-brand-300">{icon}</div> : null}
      <p className="text-base font-semibold text-ink">{title}</p>
      {description ? (
        <p className="mt-1 max-w-md text-sm text-ink-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
};

export default EmptyState;